import { useParams, useSearchParams } from 'react-router-dom';
import { useReportQuery } from '@common/cache';
import { useReportStore } from '@store';
import { useEffect } from 'react';

export const useReportItemsView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { report_id } = useParams();
  const { setReport, introspection, setFilters, clearAll } = useReportStore();

  const { data: reportDetails, isFetching } = useReportQuery({ report_id });

  // Clear store when navigating to a new report to prevent stale data
  useEffect(() => {
    if (isFetching) {
      clearAll();
    }
  }, [isFetching]);

  useEffect(() => {
    if (reportDetails) {
      const interval = searchParams.get('interval') || undefined;
      const to_date = searchParams.get('to_date') || undefined;
      const from_date = searchParams.get('from_date') || undefined;

      const effectiveInterval = interval || reportDetails.interval;
      setReport({
        ...reportDetails,
        interval: effectiveInterval as typeof reportDetails.interval,
        ...(effectiveInterval === 'custom' && {
          custom_timeframe: {
            to_date: to_date ?? reportDetails.custom_timeframe?.to_date ?? null,
            from_date:
              from_date ?? reportDetails.custom_timeframe?.from_date ?? null,
          },
        }),
      });
      setFilters(
        reportDetails.options.$and?.map(o => ({
          field: o.field,
          value: o.value,
          operator: o.operator,
          label:
            introspection?.filters?.find(f => f.field === o.field)?.label ??
            o.field,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        })) as any,
      );

      const hasTimeParams =
        searchParams.has('interval') ||
        searchParams.has('from_date') ||
        searchParams.has('to_date');
      if (hasTimeParams) {
        setSearchParams(
          prev => {
            prev.delete('interval');
            prev.delete('from_date');
            prev.delete('to_date');
            return prev;
          },
          { replace: true },
        );
      }
    }
  }, [reportDetails, introspection]);

  return {
    report_id: report_id || '',
  };
};
